import { NavigateFunction } from 'react-router-dom';

import { APP_PATH } from '@app/config/app-paths';
import { disconnect } from '@app/core/authentication/authentication.slice';
import { InAppStorage } from '@app/core/storage/in-app-storage';
import type { AppDispatch } from '@app/core/store';
import { baseApi } from '@service/base-api.service';

export const logout = (
  dispatch: AppDispatch,
  navigate: NavigateFunction,
): void => {
  InAppStorage.setJwt(null, false);
  InAppStorage.setRefreshToken(null, false);
  dispatch(disconnect());
  dispatch(baseApi.util.resetApiState());
  navigate(APP_PATH.LOGIN);
};
